<template>
  <v-app class="app">
    <menu-adm />
    <v-main class="main-content">
      <header-normal />
      <router-view />
    </v-main>
    <navegation-mobile />
  </v-app>
</template>

<script>
import MenuAdm from '@/components/MenuAdm.vue';
import HeaderNormal from '@/components/HeaderNormal.vue'
import NavegationMobile from '@/components/components-mobile/NavegationMobile.vue';

export default {
  name: 'AdminPanelLayout',
  components: {
    MenuAdm,
    HeaderNormal,
    NavegationMobile
  },
};
</script>

<style scoped>
.app {
  margin-left: 90px;
}

.main-content {
  background-color: #15092e !important;
  padding: 64px 100px 0px 229px !important;
}

@media (max-width: 890px) {
  .app {
    margin-left: 0px;
  }

  .main-content {
    padding: 0px 0px 0px 0px !important;
  }
}

@media (max-width: 1440px) {
  .main-content {
    background-color: #15092e !important;
    padding: 64px 35px 0px 229px !important;
  }
}

@media (max-width: 1024px) {
  .main-content {
    background-color: #15092e !important;
    padding: 64px 0px 0px 99px !important;
  }
}

@media (max-width: 768px) {
  .main-content {
    background-color: #15092e !important;
    padding: 0px 0px 0px 0px !important;
  }
}
</style>
